import { SnackbarAlerts } from '@sternum/ui';

import {
  SnackbarErrorIcon,
  SnackbarInformationIcon,
  SnackbarSuccessIcon,
  SnackbarWarningIcon,
} from './AppSnackbarAlerts.style';

export function AppSnackbarAlertsComponent() {
  return (
    <SnackbarAlerts
      defaults={{
        info: {
          icon: <SnackbarInformationIcon />,
        },
        success: {
          icon: <SnackbarSuccessIcon />,
        },
        warning: {
          icon: <SnackbarWarningIcon />,
        },
        error: {
          icon: <SnackbarErrorIcon />,
        },
      }}
    />
  );
}
